const ENTITY_STATUS_TABS = [
  'All',
  'Review Queue',
  'Quarantined',
  'Barred',
  'Cleared',
];

export const resolveEntityBulkTab = (activeTab?: string): string => {
  const tab = (activeTab || '').trim();
  if (!tab) {
    return 'All';
  }
  const match = ENTITY_STATUS_TABS.find(
    (label) => label.toLowerCase() === tab.toLowerCase(),
  );
  return match || 'All';
};

export const buildEntityPreviewConfirmDescription = ({
  scope,
  toStatusLabel,
  wouldUpdate,
  barredExcluded,
  tabLabel,
  riskLevelLabel,
}: {
  scope: string;
  toStatusLabel: string;
  wouldUpdate: number;
  barredExcluded: number;
  tabLabel: string;
  riskLevelLabel?: string;
}): string => {
  const itemWord = wouldUpdate === 1 ? 'item' : 'items';
  let scopePhrase = `${wouldUpdate} ${itemWord}`;

  if (scope === 'selection') {
    scopePhrase = `${wouldUpdate} selected ${itemWord}`;
  } else if (scope === 'zero_hits') {
    scopePhrase =
      tabLabel === 'All'
        ? `${wouldUpdate} ${itemWord} with no matches on All`
        : `${wouldUpdate} ${itemWord} with no matches on ${tabLabel}`;
  } else if (scope === 'risk_level') {
    const riskPhrase = riskLevelLabel ? `${riskLevelLabel} risk` : 'the selected risk level';
    scopePhrase =
      tabLabel === 'All'
        ? `${wouldUpdate} ${itemWord} with ${riskPhrase} on All`
        : `${wouldUpdate} ${itemWord} with ${riskPhrase} on ${tabLabel}`;
  } else if (scope === 'all') {
    scopePhrase = `${wouldUpdate} ${itemWord} on ${tabLabel}`;
  }

  let description = `This will change the status of ${scopePhrase} to ${toStatusLabel}.`;
  if (barredExcluded > 0) {
    const barredWord = barredExcluded === 1 ? 'item' : 'items';
    description += ` ${barredExcluded} Barred ${barredWord} will not be changed.`;
  }
  return description;
};
